import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Utils from "../../../utils";
import "../adminportal.css";
import {
    adminPost2FAGenerateQrCode,
    adminPost2FARemoveQrCode,
    adminPost2FAVerifyQrCode
} from "../../../services/AdminService";

function Admin2FA() {
    const [loading, setLoading] = useState(false);
    const [qrUrl, setQrUrl] = useState('');
    const [accountName, setAccountName] = useState('');
    const [yourKey, setYourKey] = useState('');
    const [yourCode, setYourCode] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [code, setCode] = useState('');
    let errorsObj = {
        code: ''
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        adminPost2FAGenerateQrCode()
            .then(response => {
                setIsVerified(response.data.is_verified);
                setQrUrl(response.data.url);
                setAccountName(response.data.data.qr_account_name);
                setYourKey(response.data.data.qr_key);
                setYourCode(response.data.data.qr_code);
            })
            .catch(err => {

            });
    }, []);

    const handleVerifyCode = (e) => {
        e.preventDefault();

        let error = false;
        let errorObj = {...errorsObj};
        if (!code) {
            error = true;
            errorObj.code = 'Please enter the code';
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);

        let obj = {
            code: code
        };

        adminPost2FAVerifyQrCode(obj)
            .then(response => {
                setIsVerified(true);
                setLoading(false);
                toast.success(response.data.message);
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    const handleRemoveCode = (e) => {
        e.preventDefault();

        setLoading(true);
        adminPost2FARemoveQrCode()
            .then(response => {
                setLoading(false);
                setIsVerified(false);
                setCode('');
                toast.success(response.data.message);
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <div className="admin-dashboard-container">
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" className="page-loader"/>
            </div>}
            <div className="tab-pane fade show active" id="nav-Security" role="tabpanel">
                <div className="admin-panel overflow-hidden">
                    <div className="px-4 py-2 mb-3 border-bottom border-secondary">
                        <h4 className="mb-0 fw-bold text-white">Setup Google Authentication</h4>
                        <p className="text-secondary mb-0 small">Secure your account using the Google Authenticator app</p>
                    </div>
                    <div className="px-4 py-2 shadow-none text-white">
                        <div className="row g-4">
                            {/* Step 1 */}
                            <div className="col-12 mb-2">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '32px', height: '32px' }}>1</span>
                                    <h5 className="mb-0 fw-semibold text-white">Download Authenticator App</h5>
                                </div>
                                <div className="ms-5 pt-1">
                                    <p className="text-secondary mb-2">Install the Google Authenticator app from the Apple App Store or Google Play Store on your mobile device.</p>
                                    <div className="d-flex gap-2">
                                        <span className="badge text-white border p-2 px-3 fw-normal small" style={{backgroundColor: '#2b2b40'}}>App Store</span>
                                        <span className="badge text-white border p-2 px-3 fw-normal small" style={{backgroundColor: '#2b2b40'}}>Play Store</span>
                                    </div>
                                </div>
                            </div>

                            {/* Step 2 */}
                            <div className="col-12 mb-2">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '32px', height: '32px' }}>2</span>
                                    <h5 className="mb-0 fw-semibold text-white">Scan QR Barcode</h5>
                                </div>
                                <div className="ms-5 pt-1">
                                    <p className="text-secondary mb-3">Open your authenticator app and scan the barcode below to link your account.</p>
                                    
                                    <div className="row align-items-start gy-4">
                                        {qrUrl && (
                                            <div className="col-auto">
                                                <div className="p-3 border rounded-3 bg-white shadow-sm">
                                                    <img src={qrUrl} alt="QR Code" className="img-fluid" style={{ maxWidth: '180px' }}/>
                                                </div>
                                            </div>
                                        )}

                                        {accountName && yourKey && (
                                            <div className="col-lg">
                                                <div className="p-4 rounded-3 border-start border-primary border-4" style={{backgroundColor: '#1a1a27'}}>
                                                    <h6 className="fw-bold mb-3 text-white">Can't scan the code?</h6>
                                                    <p className="small text-secondary mb-3">Manually enter the following details in your app:</p>
                                                    <div className="mb-2">
                                                        <label className="text-secondary small d-block mb-1">Account Name</label>
                                                        <code className="text-primary fw-bold" style={{ fontSize: '1rem' }}>{accountName}</code>
                                                    </div>
                                                    <div className="mb-2">
                                                        <label className="text-secondary small d-block mb-1">Your Key</label>
                                                        <code className="text-primary fw-bold" style={{ fontSize: '1rem' }}>{yourKey}</code>
                                                    </div>
                                                    {yourCode && (
                                                        <div className="mt-3 p-2 border rounded text-center" style={{borderColor: '#2b2b40'}}>
                                                            <span className="small text-secondary d-block">Verification Code</span>
                                                            <span className="h4 mb-0 fw-bold letter-spacing-2 text-white">{yourCode}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Step 3 */}
                            {!isVerified && (
                                <div className="col-12">
                                    <div className="d-flex align-items-center mb-2">
                                        <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '32px', height: '32px' }}>3</span>
                                        <h5 className="mb-0 fw-semibold text-white">Enter Verification Code</h5>
                                    </div>
                                    <div className="ms-5 pt-1">
                                        <p className="text-secondary mb-3">Enter the 6-digit code generated by your app to finalize the setup.</p>
                                        <div className="d-flex flex-column" style={{ maxWidth: '300px' }}>
                                            <input 
                                                type="text" 
                                                className={`admin-input form-control form-control-lg border-2 ${errors.code ? 'is-invalid' : ''}`}
                                                value={code}
                                                onChange={(e) => setCode(e.target.value)} 
                                                placeholder="000000"
                                                maxLength="6"
                                            />
                                            {errors.code && (<div className="invalid-feedback">{errors.code}</div>)}
                                            
                                            <button 
                                                type="button" 
                                                onClick={handleVerifyCode} 
                                                className="btn btn-primary btn-lg mt-3 w-100 shadow-sm"
                                                disabled={loading}
                                            >
                                                {loading ? 'Verifying...' : 'Verify & Enable'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Footer / Remove State */}
                            {isVerified && (
                                <div className="col-12 mt-2">
                                    <div className="alert alert-success d-flex align-items-center border-0 shadow-sm p-4 rounded-4 ms-md-5" style={{backgroundColor: 'rgba(42, 245, 152, 0.15)', color: '#2af598'}}>
                                        <div className="me-3 h4 mb-0">✓</div>
                                        <div>
                                            <h6 className="fw-bold mb-1">Two-Factor Authentication is Enabled</h6>
                                            <p className="small mb-3 text-white">Your account is currently protected by Google Authenticator.</p>
                                            <button 
                                                type="button" 
                                                onClick={handleRemoveCode}
                                                className="btn btn-outline-danger btn-sm rounded-pill px-4 fw-bold"
                                            >
                                                Disable 2FA
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Admin2FA;